import config from "@/configs";
import store from "../store";
import axios from "axios";
import util from "../utils/util";
//console.log("PING1",config.apiUrl);
const httpClient = axios.create({
  baseURL: config.apiUrl,
});

httpClient.defaults.withCredentials = false;

httpClient.interceptors.request.use(
  async (request) => {
    // store.dispatch('loadingDialog/loading', true, { root: true });
    const token = store.getters["Auth/getToken"];
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
    }

    // encrypt request body with AES-256-GCM
    if (request.data) {
      request.data = await util.aesEncrypt(request.data);
    }
    return request;
  },
  (error) => {
    //store.dispatch('loadingDialog/loading', false, { root: true });
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  async (response) => {
    // store.dispatch('loadingDialog/loading', false, { root: true });

    // decrypt response body with AES-256-GCM
    if (response.data) {
      response.data = await util.aesDecrypt(response.data);
    }
    return response;
  },
  (error) => {
    // store.dispatch('loadingDialog/loading', false, { root: true });
    return Promise.reject(error);
  }
);
export default httpClient;
